import { storageKey } from '@/lib/infra/storage';

export type OrderSortKey =
  | 'queue_position'
  | 'absolute_queue_depth'
  | 'created_time'
  | 'ticker'
  | 'yes_price'
  | 'remaining_count'
  | 'cost';

export type OrderSortDirection = 'asc' | 'desc';

export interface OrderSortPreference {
  key: OrderSortKey;
  direction: OrderSortDirection;
}

const STORAGE_KEY = storageKey('order_sort_default');

const DEFAULT: OrderSortPreference = { key: 'absolute_queue_depth', direction: 'asc' };

let current: OrderSortPreference = { ...DEFAULT };

export function initOrderSort(): OrderSortPreference {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (isValidKey(parsed.key) && isValidDirection(parsed.direction)) {
        current = { key: parsed.key, direction: parsed.direction };
        return current;
      }
    }
  } catch {
    // corrupt — fall through to default
  }
  current = { ...DEFAULT };
  return current;
}

export function getOrderSort(): OrderSortPreference {
  return current;
}

export function setOrderSort(pref: OrderSortPreference): void {
  current = pref;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pref));
}

const VALID_KEYS: OrderSortKey[] = [
  'queue_position',
  'absolute_queue_depth',
  'created_time',
  'ticker',
  'yes_price',
  'remaining_count',
  'cost',
];
const VALID_DIRS: OrderSortDirection[] = ['asc', 'desc'];

function isValidKey(v: unknown): v is OrderSortKey {
  return typeof v === 'string' && VALID_KEYS.includes(v as OrderSortKey);
}

function isValidDirection(v: unknown): v is OrderSortDirection {
  return typeof v === 'string' && VALID_DIRS.includes(v as OrderSortDirection);
}
